import {
  JOBS_URL,
  JOB_URL,
  SEARCH_CATALOGS_URL
} from 'app/utils/Constants';

import {
  get,
  post,
  put,
  patch
} from 'app/services/ApiService';

import {
  TEXT,
  EQUALS
} from 'app/hooks/useFilter';

export const getCatalog = async id => {
  let params = {
    page: 1,
    per_page: 1,
    filter_model: {
      id: [{
	filterClass: TEXT,
	filterType: EQUALS,
	value: id.toString()
      }]
    },
    sort_model: []
  }

  let resp = await getCatalogs(params);
  return resp.records[0];
}

export const getCatalogs = async params => {
  return await post(SEARCH_CATALOGS_URL(), params);
}

export const createCatalog = async params => {
  params.portal2 = true;
  return await post(JOBS_URL(), params);
}

export const updateCatalog = async (id, params) => {
  params.portal2 = true;
  return await put(JOB_URL(id), params);
}

export const destroyCatalogs = async ids => {
  let params = { ids };
  return await patch(JOBS_URL(), params);
}
